var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16240_37393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.347 4.076s3.98.828 10.27 2.257c3.31.752 11.078 2.9 14.144 7.956 2.088 3.342 1.05 7.77-2.316 9.874a7.201 7.201 0 01-7.03.333.687.687 0 00-.623.05c-.314.196-.466.6-.255.84 1.375 1.65 5.169 5.476 10.14 4.445l-11.891 7.43c3.092-4.038 1.353-9.117.45-11.062-.123-.295-.553-.335-.867-.139-.18.112-.29.335-.318.538a7.168 7.168 0 01-3.381 6.172c-3.365 2.103-7.801 1.095-9.89-2.247-3.133-5.014-1.658-12.938-.883-16.241a844.422 844.422 0 012.45-10.206zm5.422 12.32l-5.363 3.35 6.28.414 1.523 6.082 2.381-5.826 6.28.415-4.822-4.021 2.38-5.826-5.361 3.35-4.798-4.034 1.5 6.095z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16240_37393"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18z",
    fill: "#fff"
  })))));
}
SvgAvatar.displayName = 'Avatar';
export default SvgAvatar;